export const DocumentationPageENUStranslations = {
  documentationPageHeadDescription:
    'Ask us your questions. Talk to our experts.',
  documentationPageSubtitle: 'Help Center',
  documentationPageTitle: 'Get answers to your questions about our features',
};
